'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useClerk } from '@clerk/nextjs';
import { resolveLastAuthenticationStrategy } from '../_utils/auth-last-authentication-strategy';
export function useLastAuthenticationStrategy() {
  const $ = _c(5);
  const {
    client
  } = useClerk();
  const clerkStrategy = client?.lastAuthenticationStrategy;
  let t0;
  if ($[0] !== clerkStrategy) {
    t0 = () => resolveLastAuthenticationStrategy(clerkStrategy);
    $[0] = clerkStrategy;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [strategy, setStrategy] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== clerkStrategy) {
    t1 = () => {
      setStrategy(resolveLastAuthenticationStrategy(clerkStrategy));
    };
    t2 = [clerkStrategy];
    $[2] = clerkStrategy;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return strategy;
}